// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

function makeRefetchVariables(slug) {
  return {
    slug: slug
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_marketingProfileSlugAvailability(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "SlugAvailable",
    "SlugInvalid",
    "SlugUnavailable"
  ]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"marketingProfileSlugAvailability":{"u":"response_marketingProfileSlugAvailability"}}};

let wrapResponseConverterMap = {
  response_marketingProfileSlugAvailability: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"marketingProfileSlugAvailability":{"u":"response_marketingProfileSlugAvailability"}}};

let responseConverterMap = {
  response_marketingProfileSlugAvailability: unwrap_response_marketingProfileSlugAvailability
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "slug"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "marketingProfileSlugAvailability",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          }
        ],
        "type": "SlugAvailable",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "suggestedSlug",
            "storageKey": null
          }
        ],
        "type": "SlugInvalid",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v1/*: any*/)
        ],
        "type": "SlugUnavailable",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamMarketingProfileSlugFormValidationQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamMarketingProfileSlugFormValidationQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "9afe9f666c9cff7fab2d79692d19e3bc",
    "id": null,
    "metadata": {},
    "name": "TeamMarketingProfileSlugFormValidationQuery",
    "operationKind": "query",
    "text": "query TeamMarketingProfileSlugFormValidationQuery(\n  $slug: String!\n) {\n  marketingProfileSlugAvailability(slug: $slug) {\n    __typename\n    ... on SlugAvailable {\n      slug\n    }\n    ... on SlugInvalid {\n      message\n      suggestedSlug\n    }\n    ... on SlugUnavailable {\n      message\n    }\n  }\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

let wrap_response_marketingProfileSlugAvailability = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_marketingProfileSlugAvailability = unwrap_response_marketingProfileSlugAvailability;
exports.wrap_response_marketingProfileSlugAvailability = wrap_response_marketingProfileSlugAvailability;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
